/* eslint-disable react/prop-types */ // TODO: add props
import _ from 'lodash';
import { buildAnonymizer } from 'edrolo/domains/anonymizer';
import ExamGrid from './ExamGrid';
import {
  getClassAveragePercentageForThisExam,
  getTotalMarksAttemptedPerSitting,
  getTotalMarksObtainedPerSitting,
  getClassAveragesPerQuestion,
} from './ExamGridUtils';

// this can only be imported directly to avoid a circular dependency with exams.
// it's a temporary thing until this grid is retired
import { SwitchButton } from 'edrolo/domains/exams/components/SwitchButton';

import urlResolver from 'edrolo/utils/URLResolver';
import style from './ExamGridWrapper.scss';

const answerable = (question) => Number(question.marks) > 0;

const ExamGridWrapper = (props) => {
  const {
    deleteExamSitting,
    examData,
    sittingData,
    classData,
    solutionData, // Gets passed through
    onChangedResponse, // Gets passed through
    isAnonymized,
    highlightProfileId,
  } = props;
  const examIsSubmittable = examData.is_submittable;

  // Data going in: examData, sittingData, classData

  // Filter by sittings that have been submitted if the exam is submittable
  const relevantSittings = examIsSubmittable
    ? sittingData.filter((sitting) => !!sitting.submitted_ts)
    : sittingData; // Gets passed to ExamGrid

  const markedQuestionsBySection = examData.sections.map((section) =>
    _.filter(section.flatQuestions, answerable)
  ); // Gets passed to ExamGrid

  const classAveragesBySection = markedQuestionsBySection.map(
    (markedQuestionsForSection) =>
      getClassAveragesPerQuestion(markedQuestionsForSection, relevantSittings)
  ); // Gets passed to ExamGrid

  // Flatten markedQuestions
  const markedQuestionsForExam = _.flatten(markedQuestionsBySection); // Gets passed to ExamGrid

  // Calculate total marks obtained per sitting
  const totalMarksObtainedPerSitting =
    getTotalMarksObtainedPerSitting(relevantSittings);

  const totalMarksAttemptedPerSitting = getTotalMarksAttemptedPerSitting(
    relevantSittings,
    markedQuestionsForExam,
    examIsSubmittable
  );

  // Anonymise
  const studentAnonymizer = buildAnonymizer({
    seedResolver: 'user',
    schemaFields: [
      { key: 'name', type: 'full_name' },
      { key: 'last_name', type: 'last_name' },
    ],
  });
  const students = isAnonymized
    ? classData.students.map(studentAnonymizer)
    : classData.students;

  // Sort classData by submitted status / last_name
  const sortedStudents = _.sortBy(
    students,
    (student) => {
      return [
        _.find(relevantSittings, { profile: student.id }) ? 1 : 2, // 1 will appear higher than 2
        student.last_name,
        student.name,
      ];
    }
    // return studentSittingData[student.id] + student.last_name;
  );
  const classAveragePercentageForThisExam =
    getClassAveragePercentageForThisExam(
      totalMarksObtainedPerSitting,
      totalMarksAttemptedPerSitting
    );

  // Data that we need at this point: {
  //   classAverages, (array of ?
  //   ClassAveragePercentageForThisExam,
  // }

  // Cloning children and stuff was getting way too messy, so for the moment I've ditched
  // QuestionSetResultsHeader altogether and put its contents straight in here if the
  // exam is unsubmittable. -Matt 2016-11-29
  return (
    <div>
      {!examIsSubmittable && (
        <div>
          <h1>Lesson Question Results - {examData.title}</h1>
          <div className={style.subHeadingRow}>
            <h2 className={style.classId}>{classData.title}</h2>
            <SwitchButton
              allQuestionsUrl={urlResolver.reverse('question-set-index', {
                examId: examData.id,
                classId: classData.id,
              })}
            />
          </div>
        </div>
      )}
      <ExamGrid
        examData={examData}
        sittingData={sittingData}
        solutionData={solutionData}
        classData={classData}
        sortedStudents={sortedStudents}
        classAveragePercentageForThisExam={classAveragePercentageForThisExam}
        markedQuestionsForExam={markedQuestionsForExam}
        markedQuestionsBySection={markedQuestionsBySection}
        classAveragesBySection={classAveragesBySection}
        relevantSittings={relevantSittings}
        totalMarksAttemptedPerSitting={totalMarksAttemptedPerSitting}
        totalMarksObtainedPerSitting={totalMarksObtainedPerSitting}
        deleteExamSitting={deleteExamSitting}
        handleChangedResponse={onChangedResponse}
        highlightProfileId={highlightProfileId}
        show
      />
    </div>
  );
};

export default ExamGridWrapper;
